
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply component specific CSS */
tufts-clearstep{display:block;margin:0 auto;max-width:800px;overflow:hidden;padding:20px}.clearstep-iframe{border:none;display:block;height:500px;overflow:hidden;transition:height .2s ease;width:100%}`;